import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SsoDomainsContainer } from '~features/organisations';

import PageNotFoundPage from '../other/pageNotFoundPage';
import Page from '../page';

const SsoDomainsPage = () => {
	const { t } = useTranslation();
	const { id } = useParams();

	if (!id) {
		return <PageNotFoundPage />;
	}

	return (
		<Page title={t('ssoDomains')}>
			<SsoDomainsContainer organisationId={id} />
		</Page>
	);
};

export default SsoDomainsPage;
